import React, { useEffect, useState, useRef } from "react";
import "../../assets/css/inbox.css";
import "../../assets/css/style.css";
import "../../assets/css/responsive.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Info from "../../assets/images/info-b.svg";
import Logo from "../../assets/images/TKC-Logo1.png";
import LogoPw from "../../assets/images/Logo.png";
import { ApiHelper } from "../../helpers/ApiHelper";
import { API } from "../../config/api";
import Spinner from "../../components/Spinner";
import { useNavigate, useParams } from "react-router";
import OTPInput, { ResendOTP } from "otp-input-react";
import "bootstrap/dist/css/bootstrap.css";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const OtpVerification = (props) => {
  const [loader, setLoader] = useState(false);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(30);
  const [showTooltip, setShowTooltip] = useState(false);
  const [message, setMessage] = useState("");
  const [OTP, setOTP] = useState("");
  const [contact, setContact] = useState("");
  const [name, setName] = useState("");
  const [companyLogo, setCompanyLogo] = useState("");
  const params = useParams();
  const navigate = useNavigate();
  const { navigation } = props;

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(30);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  });

  async function getCandidateData() {
    setLoader(true);
    const obj = {
      intervieweeid: params.id,
    };
    await ApiHelper.post(API.getApplicantsbyId, obj)
      .then((resData) => {
        if (resData.data.success === true) {
          setContact(resData.data?.interview_data?.phone);
          setName(resData.data?.interview_data?.first_name);
          setCompanyLogo(resData?.data?.companyLogo);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  }
  useEffect(() => {
    getCandidateData();
    setMinutes(0);
    setSeconds(30);
  }, []);
  const resendOTP = () => {
    setMinutes(0);
    setSeconds(30);
    resendOtp();
  };

  const verifyOtpSubmit = async (e) => {
    e.preventDefault();
    if (OTP.length === 6) {
      setLoader(true);
      const formData = {
        intervieweeid: params.id,
        otpcode: OTP,
      };
      await ApiHelper.post(API.verifyOtp, formData, false)
        .then((resData) => {
          setLoader(false);
          if (resData.data.success === true) {
            params?.tempid !== undefined
              ? navigate(
                  "/candidateonboarding/" + params.id + "/" + params.tempid
                )
              : navigate("/candidateonboarding/" + params.id);
            toast(resData.data.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "success",
            });
          } else {
            toast(resData.data.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "error",
            });
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log(err, "err");
        });
    } else {
      setLoader(false);
      toast("Please enter the otp", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "warning",
      });
    }
  };
  const resendOtp = async () => {
    setLoader(true);
    const formData = {
      intervieweeid: params.id,
    };
    await ApiHelper.post(API.sendVerification, formData, false)
      .then((resData) => {
        setLoader(false);
        if (resData.data.status === true) {
          toast(resData.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            type: "success",
          });
        } else {
          toast(resData.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            type: "error",
          });
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err, "err");
      });
  };
  return (
    <div>
      <div className="fixHeader candPrv">
        <div className="row">
          <div className="w-100 logo-sec">
            <div className="logoCent logo-sec">
              {companyLogo !== null && (
                <img
                  src={API.avenuView + companyLogo}
                  alt="logo"
                  className="logo-inner mb-0 me-2"
                />
              )}
            </div>
            <div className="logoSide logo-sec">
              <p className="Powered-by-text">Powered by</p>
              <img src={LogoPw} alt="copy" className="logo-inner mb-0 me-2" />
            </div>
          </div>
        </div>
      </div>

      <div className="cardSpace">
        <div className="cards-otp cards has-text-centered is-wide">
          <div className="card-second">
            <div className="text-padd">
              <h4 className="welcome-text">Welcome {name}</h4>
              <p className="wel-text-one">
                Please verify your identity before proceeding with onboarding.
              </p>
              <p className="otp-text">
                An OTP code will be sent to
                <span className="otp-no"> +1 XXX XXX {contact.substr(-4)}</span>
              </p>
            </div>
            <div>
              <div className="outerWidth">
                <div className="spaceWidth">
                  <div className="main-verif">
                    <div className="algOtps">
                      <p className="verifi-code-text">Verification code</p>
                      {/* <OverlayTrigger
                        delay={{ hide: 450, show: 300 }}
                        overlay={(props) => (
                          <Tooltip {...props}>
                            Please verify your information to continue.
                          </Tooltip>

                        )}
                        placement="top" className="in" id="tooltip-top">
                        <img src={Info} alt="copy" className="verifi-code-imgs mb-0 me-2 " />
                      </OverlayTrigger> */}

                      <div className="tooltip cent">
                        <img
                          src={Info}
                          alt="copy"
                          className="verifi-code-imgs mb-0 me-2 "
                        />
                        <span class="tooltiptext">
                          Please verify your information to continue.
                        </span>
                      </div>
                    </div>
                    <div>
                      <span className="verifi-code-no">
                        {seconds > 0 || minutes > 0 ? (
                          <p>
                            {minutes < 10 ? `0${minutes}` : minutes}:
                            {seconds < 10 ? `0${seconds}` : seconds}{" "}
                          </p>
                        ) : null}
                      </span>
                    </div>
                  </div>
                  {seconds <= 0 && (
                    <div onClick={resendOTP} className="col-sm">
                      <p>
                        <a href="#" className="resend-text">
                          Resend OTP
                        </a>
                      </p>
                    </div>
                  )}
                </div>
              </div>
              <div className="otp-field mb-4">
                <OTPInput
                  className="otp-enter "
                  value={OTP}
                  onChange={setOTP}
                  autoFocus
                  OTPLength={6}
                  otpType="number"
                  disabled={false}
                />
              </div>
              <div className="text-center px-3">
                <button
                  type="button"
                  className="otp-button"
                  onClick={verifyOtpSubmit}
                >
                  Verify
                </button>
              </div>
            </div>
          </div>

          <div className="line-border cardPost">
            <div className="need-text">
              <p className="message">
                <a href="#" className="">
                  Need Help?
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* for showing toast */}
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {loader && <Spinner />}
    </div>
  );
};
export default OtpVerification;
